import {REQUEST_CUSTOMER, REQUEST_CUSTOMER_FAILURE, REQUEST_CUSTOMER_SUCCESS} from "../../../constant/master/TransCustomerConstant";

const initialState = {
    customer: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const customerReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_CUSTOMER:
            return {
                ...state,
                customer: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_CUSTOMER_SUCCESS:
            return {
                ...state,
                customer: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_CUSTOMER_FAILURE:
            return {
                ...state,
                customer: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
